import { styled } from "@vitality-ds/system";
import IconAvatarContainerStyles from "./styles/IconAvatarContainer.styles";

// eslint-disable-next-line import/prefer-default-export
export var IconAvatarContainer = styled("div", IconAvatarContainerStyles);